import React from 'react';
import { SearchContext } from './Provider';

const useSearchContext = () => React.useContext(SearchContext);

export { useSearchContext };
